/* Serien in Farbe auf /collections/sofa-kollektion (Marc, 2026-10-20, Variante „B“).

   Statt grauer 3D-Vorschauen zeigt jede Serie eine Bestseller-Farbe: Die Kacheln den
   Freisteller (`F-<Config>_<Code>_freisteller_06.jpg`), das große Bild das Raumbild der
   aktiven Kachel (`_raum_01.jpg`) — beide in derselben Farbe. Eine Farbe gilt für die
   ganze Serie. Unten im Raumbild steht die Farbleiste wie auf der Produktseite.

   Nur die Serie im Blick wechselt alle 4 s die Farbe; jede Serie startet in einer anderen.
   Ein Klick auf eine Farbe hält die Serie an und gibt sie an „Konfigurieren“ weiter
   (?stoff=). Fehlt ein Bild (404), bleibt an dieser Stelle das bisherige stehen.
   Daten: `data-so-farben` (Bestseller), `data-so-cfg` an der Kachel, `c` in `data-so-data`. */
(function () {
  var DATEIEN = 'https://cdn.shopify.com/s/files/1/0974/7673/9459/files/';
  var ROT_MS = 4000;  // Marc, 2026-10-20: mit weicher Überblendung wieder 4 s

  function start() {
    var root = document.querySelector('.fmnv-so');
    var datenEl = document.querySelector('[data-so-farben]');
    if (!root || !datenEl) return;
    var farben;
    try { farben = JSON.parse(datenEl.textContent); } catch (e) { return; }
    if (farben.length < 2) return;
    var conn = navigator.connection;
    var bewegung = !matchMedia('(prefers-reduced-motion: reduce)').matches && !(conn && conn.saveData);

    // Der Variantentitel trägt das „F-“ schon (F-MM11887_1S → F-MM11887).
    /* Weich überblenden statt hart tauschen: eine Kopie mit dem neuen Bild legt sich darüber und
       blendet ein, danach übernimmt das Original die Adresse (aus dem Cache, ohne Sprung). */
    function blende(img, url) {
      if (!url || img.getAttribute('src') === url) return;
      var alt = img.parentNode.querySelector('.so-farbe-blende');
      if (alt) alt.remove();
      var neu = img.cloneNode(false);
      ['data-so-img', 'data-so-soll', 'data-so-grau', 'onerror', 'srcset', 'sizes', 'id'].forEach(function (a) { neu.removeAttribute(a); });
      neu.classList.remove('ist-da');  // sonst stünde die Raumbild-Kopie sofort voll da
      neu.classList.add('so-farbe-blende');
      neu.alt = '';
      neu.src = url;
      img.after(neu);
      var fertig = function () { if (!neu.isConnected) return; img.src = url; neu.remove(); };
      requestAnimationFrame(function () { requestAnimationFrame(function () { neu.classList.add('ist-an'); }); });
      neu.addEventListener('transitionend', fertig);
      setTimeout(fertig, 1600);  // falls transitionend ausbleibt (Tab im Hintergrund)
    }

    var bild = function (cfg, k, art, w) { return DATEIEN + cfg + '_' + k + '_' + art + '.jpg?width=' + w; };

    [].forEach.call(root.querySelectorAll('.so-series'), function (se, nr) {
      var mood = se.querySelector('.so-mood');
      var fotos = mood && mood.querySelector('.so-mood-fotos');
      var karten = [].slice.call(se.querySelectorAll('[data-so-card][data-so-cfg]')).filter(function (k) { return k.dataset.soCfg; });
      if (!fotos || !karten.length) return;

      // Welche Config zeigt die Kachel gerade? Bei Achsen (Ausrichtung/Schlaf) aus den Daten der Gruppe.
      function cfgVon(karte) {
        var d = karte.querySelector('[data-so-data]');
        if (!d) return karte.dataset.soCfg;
        var wahl = {};
        [].forEach.call(karte.querySelectorAll('.so-axis-opt.is-on'), function (b) { wahl[b.dataset.soAxis] = b.dataset.soValue; });
        try {
          var hit = JSON.parse(d.textContent).filter(function (o) {
            return (!wahl.o || o.o === wahl.o) && (!wahl.s || o.s === wahl.s);
          })[0];
          return (hit && hit.c) || karte.dataset.soCfg;
        } catch (e) { return karte.dataset.soCfg; }
      }

      var i = (nr * 3) % farben.length;
      var aktiv = karten[0];
      var gestoppt = !bewegung, hover = false, sichtbar = false, gewaehlt = false;

      // Raumbild-Ebene über den bisherigen Serienfotos.
      var raum = document.createElement('img');
      raum.className = 'so-farbe-raum';
      raum.alt = '';
      raum.decoding = 'async';
      fotos.appendChild(raum);

      // Farbleiste unten im Raumbild.
      var leiste = document.createElement('div');
      leiste.className = 'so-farbe-leiste';
      leiste.setAttribute('role', 'radiogroup');
      leiste.setAttribute('aria-label', 'Bestseller-Farben');
      var punkte = farben.map(function (f, n) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'so-farbe-punkt';
        b.title = f.s + ' ' + f.f;
        b.setAttribute('role', 'radio');
        b.setAttribute('aria-label', f.s + ' ' + f.f);
        b.style.backgroundImage = 'url(' + f.sw + ')';
        b.addEventListener('click', function (e) {
          e.preventDefault();
          gestoppt = true; gewaehlt = true;
          zeige(n);
        });
        leiste.appendChild(b);
        return b;
      });
      var mehr = document.createElement('a');
      mehr.className = 'so-farbe-mehr';
      leiste.appendChild(mehr);
      mood.appendChild(leiste);
      se.classList.add('so-farbe-an');

      function ctaVon(karte) { return karte.querySelector('[data-so-cta]'); }
      function mitStoff(href, k) {
        var u = new URL(href, location.href);
        if (gewaehlt) u.searchParams.set('stoff', k.toLowerCase()); else u.searchParams.delete('stoff');
        return u.pathname + u.search;
      }

      /* Alle Bilder einer Farbe erst laden, dann gemeinsam tauschen (Marc, 2026-10-20: „teilweise
         versetzt“). Je Bild eine Liste von Kandidaten — die erste vorhandene gewinnt, null = keine. */
      var geladen = {};
      function lade(urls) {
        return geladen[urls[0]] || (geladen[urls[0]] = new Promise(function (ok) {
          var n = 0;
          (function weiter() {
            if (n >= urls.length) return ok(null);
            var u = urls[n++], p = new Image();
            p.onload = function () { (p.decode ? p.decode() : Promise.resolve()).catch(function () {}).then(function () { ok(u); }); };
            p.onerror = weiter;
            p.src = u;
          })();
        }));
      }
      // Ohne Diagonale (Carlisle 2-Sitzer) der frontale Freisteller, erst danach das graue Bild.
      function kandidaten(karte, k) {
        var cfg = cfgVon(karte);
        return [bild(cfg, k, 'freisteller_06', 700), bild(cfg, k, 'freisteller_05', 700)];
      }
      function ladeFarbe(k) {
        return Promise.all([lade([bild(cfgVon(aktiv), k, 'raum_01', 1000)])].concat(karten.map(function (karte) { return lade(kandidaten(karte, k)); })));
      }

      var lauf = 0;
      function zeige(n) {
        i = n;
        var f = farben[n], nr = ++lauf;
        karten.forEach(function (karte) {
          [ctaVon(karte), karte.querySelector('[data-so-media]')].forEach(function (a) {
            if (a && a.getAttribute('href')) a.setAttribute('href', mitStoff(a.getAttribute('href'), f.k));
          });
        });
        var fz = parseInt(((aktiv.querySelector('[data-so-fz]') || {}).textContent || '').replace(/\D/g, ''), 10);
        mehr.textContent = fz > farben.length ? '+' + (fz - farben.length) + ' Farben' : 'Alle Farben';
        var cta = ctaVon(aktiv);
        if (cta) mehr.href = cta.getAttribute('href');
        ladeFarbe(f.k).then(function (urls) {
          if (nr !== lauf) return;  // inzwischen andere Farbe gewählt
          punkte.forEach(function (b, m) { b.classList.toggle('is-active', m === n); b.setAttribute('aria-checked', String(m === n)); });
          if (urls[0]) {
            // Beim ersten Mal blendet die Ebene selbst ein (ist-da), danach Bild über Bild.
            if (raum.classList.contains('ist-da')) blende(raum, urls[0]);
            else { raum.src = urls[0]; raum.classList.add('ist-da'); }
          } else raum.classList.remove('ist-da');
          raum.alt = (se.querySelector('.so-series-head h2, .so-series-head h3') || {}).textContent + ' in ' + f.s + ' ' + f.f;
          karten.forEach(function (karte, m) {
            var img = karte.querySelector('[data-so-img]');
            karte.classList.toggle('so-farbe-aktiv', karte === aktiv && karten.length > 1);
            if (!img) return;
            if (!img.dataset.soGrau) img.dataset.soGrau = img.getAttribute('src');
            // Vom grauen Bild in den Freisteller hart (anderer Hintergrund), zwischen Farben weich.
            if (urls[m + 1] && karte.classList.contains('so-farbe-frei')) blende(img, urls[m + 1]);
            else img.src = urls[m + 1] || img.dataset.soGrau;
            karte.classList.toggle('so-farbe-frei', !!urls[m + 1]);
          });
          // Die nächste Farbe schon jetzt laden, damit der Wechsel wieder gemeinsam passiert.
          ladeFarbe(farben[(n + 1) % farben.length].k);
        });
      }

      karten.forEach(function (k) {
        var los = function () { if (aktiv !== k) { aktiv = k; zeige(i); } };
        k.addEventListener('mouseenter', los);
        k.addEventListener('focusin', los);
      });
      // Ausrichtung/Schlaffunktion: das Skript der Section setzt Bild und Link zurück — danach neu malen.
      se.addEventListener('click', function (e) {
        var b = e.target.closest('.so-axis-opt');
        if (!b) return;
        var k = b.closest('[data-so-card]');
        setTimeout(function () { if (k) aktiv = k; zeige(i); }, 0);
      });
      se.addEventListener('mouseenter', function () { hover = true; });
      se.addEventListener('mouseleave', function () { hover = false; });

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) { sichtbar = es[0].isIntersecting; }, { threshold: 0.5 }).observe(mood);
      }
      setInterval(function () {
        if (gestoppt || hover || !sichtbar || document.hidden) return;
        zeige((i + 1) % farben.length);
      }, ROT_MS);
      zeige(i);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
